import React from 'react';

// sort flags alphabetically to match flag-smith order
export const DefaultFlagsContext = {
  EnableAdvancedBranding: false,
  EnableChannelsClientDetails: false,
  EnableClientPersonalBranding: false,
  EnableClientInviteEnhancement: false,
  EnableCompanyChannels: false,
  EnableCopilotDomain: false,
  EnableEmailAttachments: false,
  EnableEmailNotificationsDigest: false,
  EnableEntitiesShortLinks: false,
  EnableFeeFlexibilityFlow: false,
  EnableFilesNotificationCenter: false,
  EnableFontCustomization: false,
  EnableImprovedImageCustomization: false,
  EnabledImprovedLayouts: false,
  EnableImprovedReferralsProgram: false,
  EnableInvoiceNumberProperty: false,
  EnableNewPricingPlans: false,
  EnableSubscriptionEdit: false,
  EnableSubscriptionEditSidebar: false,
  EnableUpdatedOnboardingFlow: false,
  EnableUpdatedSignatureComponents: false,
  EnableUpdatedSignatureCreationFlow: false,
  EnableNotificationSettings: false,
  EnableClientsImport: false,
};

export const FlagsContext = React.createContext(DefaultFlagsContext);
